// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.styles_main__zkO61 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  min-height: 100vh;
}

.styles_cardLogin__JACfd {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 480px;
  height: 480px;
  border-radius: 12px;
}

.styles_divHeaderLogin__z6ORa {
  background-color: #ffffff !important;
  width: 424px !important;
  height: 100px !important;
  margin-left: -40px !important;
  margin-top: -28px !important;
}

.styles_imgAltura__JCbSB {
  width: 80px;
  height: auto;
}

.styles_loginTextField__nwqG0 {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_containerSenhaTextField__ZXRdo {
  margin-top: 12px !important;
}

.styles_senhaTextField__JqYTg {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_iconeUsuario__XUoHV {
  color: #fff;
  margin-top: 60%;
  transform: translateY(-50%);
  font-size: 28px !important;
}

.styles_fundoUsuario__yGFd4 {
  background-color: #18316e;
  width: 48px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  margin-left: -14px;
}

.styles_botaoAcessar__sk3DJ {
  background-color: #18316e !important;
  margin-top: 20px !important;
  width: 100% !important;
  font-family: "Inter" !important;
  transition: all 0.3s ease !important;
  text-transform: none !important;
  font-weight: 300 !important;
}

.styles_botaoAcessar__sk3DJ:hover {
  transform: scale(0.95);
}

.styles_mensagemUsuario__ANavO {
  font-family: "Inter" !important;
  color: #000000 !important;
  margin-top: 16px !important;
  font-size: 12px !important;
}

body {
  /* background-image: url('../../images/fundo-banner.png'); */
  background-size: cover;
  background-repeat: repeat;
  background-color: #f3f6f9;
  /* Cor de fundo do projeto, caso a imagem não carregue */
  min-height: 100vh;
  width: 100%;
  min-width: 100vw;
  margin: 0;
}

.styles_botaoEsqueciSenha__oUBJ4 {
  background-color: transparent !important;
  color: #043280 !important;
  margin-top: 20px !important;
  width: 100% !important;
  font-family: "Inter", sans-serif !important;
  border: none !important;
  cursor: pointer !important;
  text-decoration: none !important;
}

.styles_botaoEsqueciSenha__oUBJ4:hover {
  text-decoration: underline;
}

.styles_botaoNaoTemConta__W818\\+ {
  color: #ffffff !important;
  background-color: #31c96f !important;
  margin-top: 12px !important;
  width: 100% !important;
  font-family: "Inter", sans-serif !important;
  border: none !important;
  cursor: pointer !important;
  text-transform: none !important;
  font-weight: 300 !important;
  text-align: center;
}

.styles_botaoNaoTemConta__W818\\+:hover {
  text-decoration: underline;
}

.styles_tituloPopup__ocNK2 {
  font-size: 28px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
}

.styles_tituloPopupContainer__fzTSw {
  display: flex !important;
  align-items: center !important;
}

.styles_botoesPopupGeral__olEEC {
  margin-bottom: 20px !important;
  margin-right: 20px !important;
}

.styles_botaoPopupSalvar__0--7A {
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__0--7A:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelar__YL-R8 {
  background-color: #ffffff !important;
  color: #5671af !important;
  border-color: #bcc2ce !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__YL-R8:hover {
  transform: scale(0.95) !important;
}

.styles_iconeTitulo__oG\\+VJ {
  font-size: 40px !important;
  color: #0f2047 !important;
  margin-right: 12px !important;
  margin-top: -8px !important;
}

.styles_container__560MJ {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.styles_tituloLogin__Emmu4 {
  font-family: "Inter" !important;
  font-size: 16px !important;
  color: #0f2047 !important;
}

.styles_linkEsqueciSenha__L2Jfy {
  margin-top: 12px !important;
}

.styles_subHeaderAppBar__Sx2\\+M {
  background-color: #8b4513; /* Cor de fundo marrom para a AppBar */
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;EACtB,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,4DAA4D;EAC5D,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,wDAAwD;EACxD,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,2CAA2C;EAC3C,uBAAuB;EACvB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;EACtB,2CAA2C;EAC3C,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.main {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  min-height: 100vh;\n}\n\n.cardLogin {\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 480px;\n  height: 480px;\n  border-radius: 12px;\n}\n\n.divHeaderLogin {\n  background-color: #ffffff !important;\n  width: 424px !important;\n  height: 100px !important;\n  margin-left: -40px !important;\n  margin-top: -28px !important;\n}\n\n.imgAltura {\n  width: 80px;\n  height: auto;\n}\n\n.loginTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.containerSenhaTextField {\n  margin-top: 12px !important;\n}\n\n.senhaTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.iconeUsuario {\n  color: #fff;\n  margin-top: 60%;\n  transform: translateY(-50%);\n  font-size: 28px !important;\n}\n\n.fundoUsuario {\n  background-color: #18316e;\n  width: 48px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  margin-left: -14px;\n}\n\n.botaoAcessar {\n  background-color: #18316e !important;\n  margin-top: 20px !important;\n  width: 100% !important;\n  font-family: \"Inter\" !important;\n  transition: all 0.3s ease !important;\n  text-transform: none !important;\n  font-weight: 300 !important;\n}\n\n.botaoAcessar:hover {\n  transform: scale(0.95);\n}\n\n.mensagemUsuario {\n  font-family: \"Inter\" !important;\n  color: #000000 !important;\n  margin-top: 16px !important;\n  font-size: 12px !important;\n}\n\nbody {\n  /* background-image: url('../../images/fundo-banner.png'); */\n  background-size: cover;\n  background-repeat: repeat;\n  background-color: #f3f6f9;\n  /* Cor de fundo do projeto, caso a imagem não carregue */\n  min-height: 100vh;\n  width: 100%;\n  min-width: 100vw;\n  margin: 0;\n}\n\n.botaoEsqueciSenha {\n  background-color: transparent !important;\n  color: #043280 !important;\n  margin-top: 20px !important;\n  width: 100% !important;\n  font-family: \"Inter\", sans-serif !important;\n  border: none !important;\n  cursor: pointer !important;\n  text-decoration: none !important;\n}\n\n.botaoEsqueciSenha:hover {\n  text-decoration: underline;\n}\n\n.botaoNaoTemConta {\n  color: #ffffff !important;\n  background-color: #31c96f !important;\n  margin-top: 12px !important;\n  width: 100% !important;\n  font-family: \"Inter\", sans-serif !important;\n  border: none !important;\n  cursor: pointer !important;\n  text-transform: none !important;\n  font-weight: 300 !important;\n  text-align: center;\n}\n\n.botaoNaoTemConta:hover {\n  text-decoration: underline;\n}\n\n.tituloPopup {\n  font-size: 28px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n}\n\n.tituloPopupContainer {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.botoesPopupGeral {\n  margin-bottom: 20px !important;\n  margin-right: 20px !important;\n}\n\n.botaoPopupSalvar {\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelar {\n  background-color: #ffffff !important;\n  color: #5671af !important;\n  border-color: #bcc2ce !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover {\n  transform: scale(0.95) !important;\n}\n\n.iconeTitulo {\n  font-size: 40px !important;\n  color: #0f2047 !important;\n  margin-right: 12px !important;\n  margin-top: -8px !important;\n}\n\n.container {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.tituloLogin {\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  color: #0f2047 !important;\n}\n\n.linkEsqueciSenha {\n  margin-top: 12px !important;\n}\n\n.subHeaderAppBar {\n  background-color: #8b4513; /* Cor de fundo marrom para a AppBar */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `styles_main__zkO61`,
	"cardLogin": `styles_cardLogin__JACfd`,
	"divHeaderLogin": `styles_divHeaderLogin__z6ORa`,
	"imgAltura": `styles_imgAltura__JCbSB`,
	"loginTextField": `styles_loginTextField__nwqG0`,
	"containerSenhaTextField": `styles_containerSenhaTextField__ZXRdo`,
	"senhaTextField": `styles_senhaTextField__JqYTg`,
	"iconeUsuario": `styles_iconeUsuario__XUoHV`,
	"fundoUsuario": `styles_fundoUsuario__yGFd4`,
	"botaoAcessar": `styles_botaoAcessar__sk3DJ`,
	"mensagemUsuario": `styles_mensagemUsuario__ANavO`,
	"botaoEsqueciSenha": `styles_botaoEsqueciSenha__oUBJ4`,
	"botaoNaoTemConta": `styles_botaoNaoTemConta__W818+`,
	"tituloPopup": `styles_tituloPopup__ocNK2`,
	"tituloPopupContainer": `styles_tituloPopupContainer__fzTSw`,
	"botoesPopupGeral": `styles_botoesPopupGeral__olEEC`,
	"botaoPopupSalvar": `styles_botaoPopupSalvar__0--7A`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__YL-R8`,
	"iconeTitulo": `styles_iconeTitulo__oG+VJ`,
	"container": `styles_container__560MJ`,
	"tituloLogin": `styles_tituloLogin__Emmu4`,
	"linkEsqueciSenha": `styles_linkEsqueciSenha__L2Jfy`,
	"subHeaderAppBar": `styles_subHeaderAppBar__Sx2+M`
};
export default ___CSS_LOADER_EXPORT___;
